import styled from 'styled-components/macro';

export const TimeWindowsTitle = styled.h1`
  // font-family: Rubik; // TODO: connect font
  font-weight: 300;
  padding: 20px 26px 0 26px;
  font-size: 28px;
  line-height: 31.5px;
`;

// TODO: problem, when it wraps components like Calendar. investigate nested styles like div > div
export const BenchmarkContainer = styled.div`
  padding: 20px 26px;
`;
